import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  list,
  homePage,
  terms,
  remainingDays
} from '@hobs/constants/exercises';

class Exercises extends BaseReducer {
  static defaultState = {
    list: [],
    currentPage: null,
    currentTermPage: null,
    remainingDayObject: {}
  };

  constructor() {
    super(Exercises.defaultState);

    this.actionMap = {
      [list.SUCCESS]: this.addExercisesList,
      [homePage.SUCCESS]: this.addExercisesHomePage,
      [terms.SUCCESS]: this.addExercisesTerms,
      [remainingDays.SUCCESS]: this.addRemainingDayObject
    };
  }

  addExercisesList = (state, action) => {
    return Object.assign({}, state, { list: action.exercises });
  };

  addExercisesHomePage = (state, action) => {
    return Object.assign({}, state, { currentPage: action.page });
  };

  addExercisesTerms = (state, action) => {
    return Object.assign({}, state, { currentTermPage: action.page });
  };

  addRemainingDayObject = (state, action) => {
    return Object.assign({}, state, { remainingDayObject: action.payload });
  };
}
export default new Exercises().reducer;
